import { customAxios } from './customAxios'

export function uploadDocument(body, idDocumento, fileName, idPratica) {
  const config = {
    params: {
      fileName,
      idPratica,
      folderId: idDocumento,
    },
    headers: {
      AuthToken: JSON.parse(localStorage.getItem('token')),
    },
  }
  const data = body
  return customAxios.post(
    process.env.REACT_APP_BACKEND_HOST +
      `/` +
      process.env.REACT_APP_PATH_NEW_PREFIX +
      `/uploadDocument?autorename=true`,
    data,
    config,
  )
}
